import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { FULFILLMENT_PROVIDER } from '../../../../filters/constants';
import { messages } from './messages';

export const FulfillmentProvider = () => {
  return {
    id: FULFILLMENT_PROVIDER,
    type: OptionFormTypes.TYPE_NUMBER_COMPARISON,
    filterValue: 'SellerFillProviderId',
    displayName: <FormattedMessage {...messages.fulfillmentProvider} />,
    render: (criteriaInformations) => {
      return renderFormBasedOnType(OptionFormTypes.TYPE_NUMBER_COMPARISON, criteriaInformations);
    },
  };
};
